import axios from "axios";
import { toast } from "react-toastify";

import { TOASTIFY_OPTIONS } from "../style/global";

let url, urlNoAuth;
if (process.env.NODE_ENV === "development") {
  url = "http://localhost:5000/panel/adm";
  urlNoAuth = "http://localhost:5000";
} else {
  url = "https://server.spread.chat/panel/adm";
  urlNoAuth = "https://server.spread.chat";
}

const ERRORS_RESPONSE = {
  NETWORK_ERROR:
    "Ops! Houve um erro com o servidor. Aguarde e volte novamente mais tarde",
};

//Model for requisitions with axios:
const api = axios.create({
  baseURL: url,
});

const authApi = axios.create({
  baseURL: url,
});

const noAuth = axios.create({
  baseURL: urlNoAuth,
});

api.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    if (error.message === "Network Error") {
      const apiError = {
        code: 500,
        message: ERRORS_RESPONSE.NETWORK_ERROR,
        error: error.message,
      };
      toast.error(apiError.message, TOASTIFY_OPTIONS);
      return Promise.reject(apiError);
    }
    return Promise.reject(error.response.data);
  }
);
api.interceptors.response.use(
  function (config) {
    return config;
  },
  function (error) {
    if (error.message === "Network Error") {
      const apiError = {
        code: 500,
        message: ERRORS_RESPONSE.NETWORK_ERROR,
        error: error.message,
      };
      return Promise.reject(apiError);
    }
    toast.error(error.response.data.message, TOASTIFY_OPTIONS);
    return Promise.reject(error.response.data);
  }
);
authApi.interceptors.request.use(
  function (config) {
    config.headers["authorization"] = `Bearer ${localStorage.getItem("token")}`;

    return config;
  },
  function (error) {
    if (error.message === "Network Error") {
      toast.error(ERRORS_RESPONSE.NETWORK_ERROR, TOASTIFY_OPTIONS);
      return Promise.reject(ERRORS_RESPONSE.NETWORK_ERROR);
    }
    return Promise.reject(error.response.data);
  }
);
authApi.interceptors.response.use(
  function (config) {
    return config;
  },
  function (error) {
    if (error.message === "Network Error") {
      const apiError = {
        code: 500,
        message: ERRORS_RESPONSE.NETWORK_ERROR,
        error: error.message,
      };
      return Promise.reject(apiError);
    }
    toast.error(error.response.data.message, TOASTIFY_OPTIONS);
    return Promise.reject(error.response.data);
  }
);

export { api, authApi, noAuth };
